// Normalises an axios error's response body into a plain string that is safe
// to hand to sonner / toast.error(). FastAPI 422 responses have a `detail`
// that is an array of objects, which would otherwise crash React when passed
// as a toast child.
export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || d?.message || String(d)).join(", ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return err?.message || fallback;
}
